import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { styled } from 'styled-components';
const getColor = (color) => {
    if (color === undefined)
        return undefined;
    if (typeof color === 'string')
        return color;
    // eslint-disable-next-line no-console
    console.error('<ChartLegend /> not a "string" colors ');
    return undefined;
};
const ColorBox = styled.span `
  height: 12px;
  width: 12px;
  display: inline-block;
  flex-shrink: 0;
  border-radius: 3px;
`;
const List = styled.ul `
  display: flex;
  align-items: center;
  justify-items: center;
  justify-content: center;
  flex-flow: row wrap;
  gap: 16px;
  margin-bottom: 1em;
  line-height: 1em;
`;
const ListLi = styled.li `
  display: inline-flex;
  cursor: pointer;
  align-items: center;
  display: flex;
  flex-flow: row nowrap;
  gap: 6px;
`;
export const ChartLegend = ({ items }) => items.length === 0 ? null : (_jsx(List, { children: items.map((item) => (_jsxs(ListLi, { onClick: () => item.onClick(), children: [_jsx(ColorBox, { style: {
                    background: getColor(item.fillStyle),
                    borderColor: getColor(item.strokeStyle),
                    borderWidth: item.lineWidth ? `${item.lineWidth}px` : undefined,
                } }), _jsx("span", { style: {
                    textDecoration: item.hidden ? 'line-through' : '',
                    color: getColor(item.fontColor),
                }, children: item.text })] }, item.text))) }));
